import { ProjectApi } from 'api/ProjectApi';
import { backendApiClient } from 'container/backendApiClient';

export const projectApi: ProjectApi = new ProjectApi(backendApiClient);
